import React, {Component} from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from "prop-types";
import FeedbackImage from '../elements/feedback/FeedbackImage';
import ContentContainer from "../elements/ContentContainer";

export default class FeedbackEffect extends Component {
  static propTypes = {
    image: PropTypes.any,
    ministry: PropTypes.string,
    ministryIcon: PropTypes.string,
    description: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    unit: __('sim_punten'),
    className: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      image: this.props.image,
      ministry: this.props.ministry,
      ministryIcon: this.props.ministryIcon,
      description: this.props.description,
      disaster: this.props.disaster,
      subtitle: this.props.subtitle
    };
  }

  renderFeedbackImageText = (text) => {
    const elem = [];

    if(
        text &&
        text !== '<p>-</p>' &&
        text !== '<p>- </p>' &&
        text !== '<p> -</p>'
    ) {
      elem.push(
          <div key={'fit-' + text.substr(0,10)} className={`feedback-image-text`}>
            <span dangerouslySetInnerHTML={{__html: text}}/>
          </div>
      );
      elem.push(<div key={'fit-text'} className="feedback-image-text"/>);
      return elem;
    }

  }

  componentDidMount() {
  }

  render() {
    let points = this.props.points === "-" ? 0 : this.props.points;
    if(this.props.points >= 0) points = `+${points}`;

    const imageText = this.renderFeedbackImageText(this.state.description);

    return (
      <div className={`single-effect-container ${this.props.difficulty === 'BASIC' ? 'single-effect-container--basic' : ''} ${this.props.className}`}>
        <div className={'container'}>
          {
            this.props.minimal ? null
              : <div className="effectItem"><FeedbackImage
                description={this.state.description}
                image={this.state.image}/></div>
          }
          <div className="effectItem">
            <ContentContainer darkBg={true}>
              <div className={'content-wrapper'}>
                {this.props.difficulty !== 'BASIC' ? (
                  <div className={'single-effect-header'}>
                    <div className={'single-ministry'}>
                      <div className={'icon'}>
                        <img alt={'ministry'} src={this.state.ministryIcon}/>
                      </div>
                      {this.props.pointsTitle ? (
                        <span>{this.state.ministry}<span className="thin-subtitle">| {this.props.pointsTitle}</span></span>
                      ) : (
                        <span>{this.state.ministry}</span>
                      )}
                      { this.state.subtitle ?
                        <p> |{this.state.subtitle}</p>
                        : null }
                    </div>
                    {!this.props.pointsTitle ? (
                      <div className={'single-points'}>
                        <span content={points}>{points}<p content={__(this.props.unit)}>{__(this.props.unit)}</p></span>
                      </div>
                    ) : null}
                  </div>
                ) : null}

                {this.props.children}
              </div>
            </ContentContainer>
          </div>
          {imageText ? imageText : null}

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/desktop/FeedbackEffect.js